import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, apiKey] as const

export type vkmfCredType = (typeof credentialTypes)[number]

export const vkmfDocumentTypes = [
  'signed-bol',
  'other',
  'weight-cert',
  'proof-of-delivery',
  'pickup-photo',
  'delivery-photo',
] as const satisfies readonly DocumentType[]

export const vkmf: CarrierDef<vkmfCredType> = {
  name: 'Van Kam Freightway',
  scac: 'vkmf',
  credentialTypes,
  legacyCredMap: [...userPassMap, ['api-key', 'apiKey']],
  engineLayers: ['documents'],
  documentTypes: vkmfDocumentTypes,
}
